const formatUserFullName = (firstName, lastName) => {
    return `${firstName ? firstName : ''} ${lastName ? lastName : ''}`.trim();
};
const formatUserInitials = (firstName, lastName) => {
    return ((firstName && firstName.length > 0 ? firstName.substring(0, 1) : '') +
        (lastName && lastName.length > 0 ? lastName.substring(0, 1) : '')).trim();
};
class User {
    constructor(id, firstName, lastName, hasAvatar) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.hasAvatar = hasAvatar;
        this.name = formatUserFullName(firstName, lastName);
        this.initials = formatUserInitials(firstName, lastName);
    }
}

export { User, User as default, formatUserFullName, formatUserInitials };
